var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.audioSource !== '')?_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audioSource,"type":"audio/mpeg"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }